/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface MarkSkillAreaAsDeleted$Params {
  skillAreaID?: number;
}

export function MarkSkillAreaAsDeleted(http: HttpClient, rootUrl: string, params?: MarkSkillAreaAsDeleted$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, MarkSkillAreaAsDeleted.PATH, 'post');
  if (params) {
    rb.query('skillAreaID', params.skillAreaID, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

MarkSkillAreaAsDeleted.PATH = '/api/Supervisor/MarkSkillAreaAsDeleted';
